document.addEventListener("DOMContentLoaded", function () {
  // Check if we are on the homepage
  if (window.location.pathname === '/') {
    // Add drag functionality to desktop sliders
    const sliders = document.querySelectorAll('.slider');

    sliders.forEach((slider) => {
      let isDragging = false;
      let startPosition, scrollLeft;
      let hasMoved = false;

      slider.addEventListener('mousedown', (e) => {
        isDragging = true;
        hasMoved = false;
        startPosition = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        e.preventDefault();
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();

        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startPosition) * 1; // Adjust for sensitivity
        slider.scrollLeft = scrollLeft - walk;

        if (Math.abs(walk) > 1) hasMoved = true;
      });

      slider.addEventListener('mouseup', () => {
        isDragging = false;
      });

      slider.addEventListener('mouseleave', () => {
        isDragging = false;
      });

      // Prevent click when dragging
      slider.addEventListener('click', (e) => {
        if (hasMoved) {
          e.preventDefault();
        }
      });
    });
  }
});
